export default {
    HEADER: 'WEBSAJT',
    PLACEHOLDER_NAME: 'Unesite ime sajta',
    LABEL_NAME: 'Naziv',
    PLACEHOLDER_DOMAIN: 'Unesite domen sajta',
    LABEL_DOMAIN: 'Domen',
    LABEL_COMPANY: 'Kompanija',
    LABEL_HOME_TYPE: 'Tip početne strane',
    LABEL_MENU_TYPE: 'Tip menija',
    LABEL_ARTICLE_TYPE: 'Tip artikla',
    LABEL_DESCRIPTION: 'Opis',
    PLACEHOLDER_DESCRIPTION: 'Unesite opis sajta',
    CANCEL: 'Poništi',
    SUBMIT: 'Sačuvaj',
};
